import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { CLEAR_ERRORS, CLEAR_LOADER, SET_LOADER, VEDNOR_REFERRALS } from "../../types";
import { setErrors } from "../errorActions";

export const get_vendor_referrals = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let response = await axios.get(`${serverApi}/vendor/invite-friend`, {
      headers: {
        Authorization: token,
      },
    });
    if (response.status === 200) {
      dispatch({ type: VEDNOR_REFERRALS, payload: response.data });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
